import React from 'react';
import {QuestionRowSelector, ActiveQuestionRow} from './QuestionRow';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

class QuestionBuilder extends React.Component {

  static propTypes = {
    groupKey: PropTypes.string.isRequired,
    toggle: PropTypes.string,
    showAllRows: PropTypes.bool
  };

  constructor(props) {
    super(props);
    let { showAllRows, initialRows = [{}], questionRows } = props;
    let activeRows = initialRows;
    if(showAllRows){
      activeRows = questionRows.map(row => {
        const foundRow = initialRows.find(r => (r.questionRow && r.questionRow.key === row.key));
        return {
          questionRow: foundRow ? foundRow.questionRow : row,
          checked: !!foundRow
        };
      });
    }

    this.state = {
      activeRows
    };
  }

  addRow = () => {
    this.setState({
      activeRows: [
        ...this.state.activeRows,
        {}
      ]
    });
  };

  saveQuestionRows = rows => {
    const questionRows = rows.filter(r => r.questionRow).map(r => r.questionRow.key);
    const {groupKey} = this.props;
    this.props.answerService.saveAnswer({
      appkey: groupKey,
      value: questionRows,
      timestamp: new Date()
    });
  };

  removeQuestionRowValues = (questionRow = {}) => {
    (questionRow.questions || []).forEach(question => {
      this.props.answerService.removeAnswer(`${questionRow.key}_${question.key}`);
    });
  };

  saveQuestionBuilderValues = debounce( () => {
    const updatedRows = this.state.activeRows.map( row => {
      if (row.hasOwnProperty('questionRow')) {
        (row.questionRow.questions || []).map(question => {
          if (question.hasOwnProperty('validForUpdate')) {
            if (question.validForUpdate) {
              this.props.answerService.saveAnswer({
                appkey: `${row.questionRow.key}_${question.key}`,
                value: question.answer,
                timestamp: new Date()
              });
              console.log(`answer saved to service: ${question.answer} for ${row.questionRow.key}_${question.key}`);
            } else {
              this.props.answerService.removeAnswer(`${row.questionRow.key}_${question.key}`);
            }
            delete question.validForUpdate;
          }
          return question;
        });
      }
      return row;
    });

    this.setState({
      activeRows: updatedRows
    });
  }, 500);

  render() {
    const {
      questionRows,
      toggle,
      showAllRows
    } = this.props;

    const {
      activeRows
    } = this.state;

    const selectedRows = new Set(activeRows.filter(t => t.questionRow).map(t => t.questionRow.key));

    const availableRowOptions = questionRows.filter(({key}) => {
      if (key === toggle) {
        return selectedRows.size === 0;
      } else {
        return !selectedRows.has(key);
      }
    });

    const renderedQuestionRows = activeRows.map((row, index) => {
      /*A row has been added in the dropdown mode*/
      const rowAdded = (value) => {
        console.log(`adding row: ${value}`);
        row.questionRow = questionRows.find(r => r.key === value);
        let newRows = [];
        if (value === toggle) {
          newRows = [row];
          questionRows.filter(r => r.key !== toggle).forEach(this.removeQuestionRowValues);
        } else {
          newRows = [...activeRows];
        }
        this.saveQuestionRows(newRows);
        this.setState({
          activeRows: newRows
        });
      };
      /*A row has been removed from the dropdown mode options*/
      const rowRemoved = () => {
        console.log(`removing row: ${row.key}`);
        activeRows.splice(index, 1);
        this.removeQuestionRowValues(row.questionRow);
        this.saveQuestionRows(activeRows);
        this.setState({
          activeRows: activeRows.length ? [...activeRows] : [{}]
        });
      };
      /*A row has been toggled in the showAll mode by clicking the checkbox*/
      const rowCheckboxClicked = (rowIsActive) => {
        console.log(`toggled row: ${row.questionRow.key}`);
        row.checked = rowIsActive;
        if(!rowIsActive){
          (row.questionRow.questions || []).forEach(question => {
            delete question.answer;
          });
          this.removeQuestionRowValues(row.questionRow);
        }
        this.saveQuestionRows(activeRows.filter(r => r.checked));
        this.setState({
          activeRows: [...activeRows]
        });
      };
      /*A questions value has been changed*/
      const questionChanged = (questionKey, answer, passedValidation) => {
        row.questionRow.questions.find(question => question.key === questionKey).answer = answer;
        row.questionRow.questions.find(question => question.key === questionKey).validForUpdate = passedValidation;
        this.setState({
          activeRows: [...activeRows]
        });

        //call debounce function to save whole row of answers
        this.saveQuestionBuilderValues();
      };
      return row.questionRow ?
        <ActiveQuestionRow
          {...row}
          key={index}
          onChange={questionChanged}
          onRemove={rowRemoved}
          isToggle={row.questionRow.key === toggle}
          showAllMode={showAllRows}
          onChecked={rowCheckboxClicked}
        /> :
        <QuestionRowSelector
          key={index}
          availableRows={availableRowOptions}
          onChange={rowAdded}
          onRemove={rowRemoved}
          disableRemove={index === 0 && activeRows.length === 1}
        />;
    });

    const classes = classnames({
      'questionBuilder-panel': true
    });

    const toggleSelected = activeRows.find(({questionRow = {}}) => questionRow.key === toggle);

    const newButton = (activeRows.length < questionRows.filter(r => r.key !== toggle).length && !toggleSelected && !showAllRows) ?
      <div className="text-center">
        <button className="btn btn-secondary new" onClick={this.addRow}>
          <FormattedMessage {...MessageDefinitions.addRow} />
          <FontAwesome name="plus"/>
        </button>
      </div>
      : null;

    return <div className={classes}>
      {renderedQuestionRows}
      {newButton}
    </div>;
  }
}

export default QuestionBuilder;



/** WEBPACK FOOTER **
 ** ./src/main/js/questionGroupBuilder/components/QuestionBuilder.js
 **/